module.exports = __webpack_public_path__ + "static/media/technology.a90a3cc6.svg";